import { type PageContext, _ } from '@zto/zpage'
import { DialogType } from '@/config'
import { filterSubmitData } from '@/utils'

import {
  normalizeTemplateLayers,
  retrieveTemplateCells,
  validateTemplateCells
} from '@/components/tdl/device/cell-template/util'
import { isDisabled } from 'packages/zpage/packages/runtime/src/utils/helper'

// 新增/编辑对话框
export const addEditDialog = (dialogType: DialogType) => {
  const isView = dialogType === DialogType.VIEW

  const disabled = isView

  return {
    width: 800,
    labelWidth: 100,
    noPadding: false,

    formAttrs: {
      disabled
    },

    onShow: async ({ app, data }: PageContext) => {
      const payload = { ...data }

      payload._templateLayers = normalizeTemplateLayers(payload)

      return { payload }
    },

    beforeSubmit: async ({ app, data }: PageContext, model: any, options: any) => {
      let payload = _.deepClone(model.value)

      const cells = retrieveTemplateCells(payload._templateLayers, payload.layers)

      const validMessage = validateTemplateCells(cells)

      if (validMessage) {
        app.ui.showMessageBox({ type: 'warning', message: validMessage })
        return false
      }

      payload.template = cells

      payload = filterSubmitData(payload)

      return payload
    },

    formItems: [
      {
        type: 'input',
        prop: 'templateName',
        label: '模版名称',
        placeholder: '如：T9-标准9格口',
        maxlength: 20,
        trim: true,
        span: 12
      },
      {
        label: '布局配置',
        type: 'checkbox',
        checkType: 'radio',
        buttonType: 'button',
        prop: 'layers',
        default: 3,
        options: [
          { label: '1层', value: 1 },
          { label: '2层', value: 2 },
          { label: '3层', value: 3 }
        ]
      },
      {
        label: false,
        cmpt: ({ data }: PageContext) => {
          return {
            type: 'CCarCellTemplateEditor',
            templateLayers: data._templateLayers,
            layerCount: data.layers,
            isView
          }
        },
        span: 24,
        autoHeight: true
      }
    ]
  }
}
